import {BrowserRouter, Route, Routes} from "react-router-dom";
import {AuthProvider} from "./AuthContext";
import {SiteShell} from "./components/SiteShell";
import {I18nProvider} from "./i18n";
import {HomePage} from "./pages/HomePage";
import {LoginPage} from "./pages/LoginPage";
import {ModelPage} from "./pages/ModelPage";
import {PwsoPage} from "./pages/PwsoPage";

export function App() {
  return <I18nProvider><AuthProvider><BrowserRouter><SiteShell><Routes><Route path="/" element={<HomePage/>}/><Route path="/DL/pwso" element={<PwsoPage/>}/><Route path="/DL/pwso/model" element={<ModelPage/>}/><Route path="/login" element={<LoginPage/>}/><Route path="*" element={<HomePage/>}/></Routes></SiteShell></BrowserRouter></AuthProvider></I18nProvider>;
}
